<template>
  <div>
    <b-button
      variant="success"
      @click="create"
    >
      New Book
    </b-button>
    <br><br>
    <Search
      route="/cpbooks"
      placeholder="Find book by id (exact match)"
    />
    <DataTable
      id="id"
      api="/admin/cpbooks"
      id-url="/cpbooks/"
    />
  </div>
</template>

<script>
import DataTable from '@core/components/data-table/DataTable.vue'
import Search from '@core/components/search/Search.vue'

import {
  BButton,
} from 'bootstrap-vue'

export default {
  components: {
    DataTable,
    BButton,
    Search,
  },
  data() {
    return {
    }
  },
  methods: {
    create() {
      this.$router.push('/cpbooks/add')
    },
  },
}
</script>
